export default __webpack_public_path__ + "static/media/We Energy_ΗΛ.7e3e3013.png";